import { cn } from "@/lib/utils";
import { ComponentProps, forwardRef } from "react";

import { Icon } from "./Icon";

type IconBoxProps = Omit<ComponentProps<typeof Icon>, "fallback"> & {
    name: IconName;
    size?: "xl" | "large" | "medium" | "small" | "extraSmall";
    color?: string; // Tailwind class string (e.g., "text-primary-main", "text-foreground")
    noIconSize?: boolean;
};

const iconSizeClasses = {
    xl: "w-8 h-8",
    large: "w-7 h-7",
    medium: "w-6 h-6",
    small: "w-5 h-5",
    extraSmall: "w-4 h-4"
} as const;

export const IconBox = forwardRef<HTMLElement, IconBoxProps>(
    (
        {
            size = "large",
            color = "text-foreground",
            className,
            name,
            noIconSize = false,
            ...props
        },
        ref
    ) => {
        const classes = cn(
            !noIconSize && iconSizeClasses[size],
            color,
            "inline-flex items-center justify-center",
            className
        );

        return (
            <Icon
                {...props}
                name={name}
                ref={ref}
                className={classes}
                fallback={<div className={classes} aria-hidden="true" />}
            />
        );
    }
);

IconBox.displayName = "IconBox";
